import { render } from "./OrderNotes.vue?vue&type=template&id=1d6959bc&ts=true"
import script from "./OrderNotes?vue&type=script&lang=ts"
export * from "./OrderNotes?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__